(() => {
  if (window.BonumChoiceUX) {
    window.BonumChoiceUX.init(document);
    return;
  }
  const controllers = new WeakMap();
  const activeControllers = new Set();
  const flavourSelector = '[data-flavors], [data-bp-flavours]';
  function text(node, value) {
    if (node.textContent !== value) node.textContent = value;
  }
  function stateFor(form) {
    const fields = form.querySelector(flavourSelector);
    const selects = fields ? Array.from(fields.querySelectorAll('select')).filter(select => select.name.startsWith('properties[Sabor ')) : [];
    const selected = selects.filter(select => select.value !== '');
    const price = form.querySelector('[data-bp-total], .bonum-order__price');
    const submit = form.querySelector('[data-bp-submit], .bonum-order__submit');
    return {
      selects,
      count: selects.length,
      chosen: selected.length,
      firstMissing: selects.find(select => select.value === ''),
      price: price ? price.textContent.trim() : '',
      submit,
      available: Boolean(submit && !submit.disabled)
    };
  }
  function create(tag, className) {
    const node = document.createElement(tag);
    node.className = className;
    return node;
  }
  function mount(form) {
    if (controllers.has(form)) return controllers.get(form);
    const fields = form.querySelector(flavourSelector);
    if (!fields) return;
    const dialog = form.closest('dialog');
    const halloween = Boolean(form.closest('.bh'));
    const progressBox = create('div', 'bn-choice-progress' + (halloween ? ' bn-choice-progress--halloween' : ''));
    const progressHead = create('div', 'bn-choice-progress__head');
    const progressTitle = create('strong', '');
    progressTitle.textContent = 'A sua seleção';
    const progressLabel = create('span', 'bn-choice-progress__count');
    progressHead.append(progressTitle, progressLabel);
    const progress = create('progress', 'bn-choice-progress__meter');
    progress.setAttribute('aria-label', 'Progresso da escolha dos recheios');
    const status = create('p', 'bn-choice-progress__status');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    progressBox.append(progressHead, progress, status);
    fields.before(progressBox);
    const bar = create('div', 'bn-mobile-order' + (halloween ? ' bn-mobile-order--halloween' : ''));
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Resumo da sua seleção');
    const summary = create('div', 'bn-mobile-order__summary');
    const totalLabel = create('span', 'bn-mobile-order__label');
    totalLabel.textContent = 'Total';
    const total = create('strong', 'bn-mobile-order__price');
    const compactCount = create('span', 'bn-mobile-order__count');
    summary.append(totalLabel, total, compactCount);
    const button = create('button', 'bn-mobile-order__button');
    button.type = 'button';
    button.textContent = 'Adicionar ao carrinho';
    bar.append(summary, button);
    const spacer = create('div', 'bn-order-spacer');
    spacer.setAttribute('aria-hidden', 'true');
    const host = dialog || document.body;
    host.append(spacer, bar);
    if (dialog) bar.classList.add('bn-mobile-order--dialog');
    let queued = false;
    function refresh() {
      if (!form.isConnected) {
        destroy();
        return;
      }
      const state = stateFor(form);
      progressBox.hidden = state.count === 0;
      progress.max = Math.max(state.count, 1);
      progress.value = state.chosen;
      text(progressLabel, state.chosen + ' de ' + state.count + ' escolhidos');
      const remaining = state.count - state.chosen;
      const complete = state.count > 0 && remaining === 0;
      progressBox.classList.toggle('is-complete', complete);
      text(status, complete ? 'Tudo escolhido! A sua seleção está pronta.' :
        remaining === 1 ? 'Falta escolher o recheio da BONUM ' + (state.selects.indexOf(state.firstMissing) + 1) + '.' :
        'Faltam ' + remaining + ' recheios.');
      state.selects.forEach(select => {
        select.dataset.bnFilled = select.value !== '' ? 'true' : 'false';
      });
      text(total, state.price);
      text(compactCount, state.chosen + ' / ' + state.count + ' recheios');
      button.disabled = !state.available;
      text(button, state.available ? 'Adicionar ao carrinho' : 'Indisponível');
      const active = document.activeElement;
      const editing = active && form.contains(active) && active.matches('textarea, input[type="text"], input[type="email"], input:not([type])');
      const inactive = state.count === 0 || !state.price || Boolean(dialog && !dialog.open);
      bar.hidden = inactive || Boolean(editing);
      spacer.hidden = inactive;
    }
    function schedule() {
      if (queued) return;
      queued = true;
      queueMicrotask(() => {
        queued = false;
        refresh();
      });
    }
    button.addEventListener('click', () => {
      const state = stateFor(form);
      if (!state.available) return;
      if (state.firstMissing) {
        state.firstMissing.focus({ preventScroll: true });
        state.firstMissing.scrollIntoView({
          block: 'center',
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
        state.firstMissing.reportValidity();
        return;
      }
      form.requestSubmit(state.submit);
    });
    ['change', 'input', 'reset', 'focusin', 'focusout'].forEach(event => form.addEventListener(event, schedule));
    const observer = new MutationObserver(records => {
      if (records.some(record => !progressBox.contains(record.target))) schedule();
    });
    observer.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    let dialogObserver;
    if (dialog) {
      dialogObserver = new MutationObserver(schedule);
      dialogObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });
      dialog.addEventListener('close', schedule);
    }
    function destroy() {
      observer.disconnect();
      if (dialogObserver) dialogObserver.disconnect();
      bar.remove();
      spacer.remove();
      activeControllers.delete(controller);
      controllers.delete(form);
    }
    const controller = { form, refresh, destroy };
    controllers.set(form, controller);
    activeControllers.add(controller);
    refresh();
    return controller;
  }
  function init(scope) {
    activeControllers.forEach(controller => { if (!controller.form.isConnected) controller.destroy(); });
    scope.querySelectorAll('.bonum-order form, [data-bp-direct-form], [data-bp-detail-dialog] form').forEach(form => {
      const controller = mount(form);
      if (controller) controller.refresh();
    });
  }
  window.BonumChoiceUX = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    activeControllers.forEach(controller => { if (event.target.contains(controller.form)) controller.destroy(); });
  });
})();